import React, { useEffect, useState } from "react";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import drumAudio from "./audio/ultra-long-90second-drumroll_ceremony-23168.mp3";
import confetti from "./animation/blast_animation";
import { Toast } from "../../../CustomComponent/toast";

function formatToIndianNumberingSystem(number) {
  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  });
  return formatter.format(number);
}

const LeaderBoard = () => {
  const [data, setData] = useState();
  const [popUpRevenue, setPopUpRevenue] = useState();
  const [totalRevenue, setTotalRevenue] = useState();

  useEffect(() => {
    const getLeaderBoardData = () => {
      performRequest("GET", "/allTablesCount/leaderBoardData")
        .then((res) => {
          if (res.status === 200) {
            setData(res?.data?.leaderBoard);
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    };
    // Call immediately
    getLeaderBoardData();

    // Call every 5 minutes
    const interval = setInterval(() => {
      getLeaderBoardData();
    }, 5 * 60 * 1000);

    // Cleanup
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      performRequest("GET", "/incentive/getRevenueGenratedBeforeFiveMin")
        .then((res) => {
          if (
            res.status === 200 &&
            res.data &&
            res.data?.revenueStatus?.length > 0
          ) {
            for (let i = 0; i < res.data?.revenueStatus?.length; i++) {
              setTimeout(() => {
                setPopUpRevenue(res.data?.revenueStatus[i]);
                setTotalRevenue(res.data?.totalCount);
              }, i * 40 * 1000);
            }
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);
  const startSound = (sound, time) => {
    setTimeout(() => {
      sound.pause();
      sound.currentTime = 0;
      setPopUpRevenue();
      setTotalRevenue();
      confetti.stop();
      document.getElementById("open-modal").click();
    }, time * 1000);
    sound.play();
    confetti.start(time * 1000);
  };

  useEffect(() => {
    if (totalRevenue) {
      document.getElementById("open-modal").click();
      let sound = new Audio(drumAudio);
      if (sound) {
        startSound(sound, 30);
      }
    }
  }, [totalRevenue]);

  const getFontSize = (index) => {
    if (index === 0) {
      return { fontSize: "140%" };
    } else if (index === 1) {
      return { fontSize: "130%" };
    } else if (index === 2) {
      return { fontSize: "120%" };
    }
  };

  return (
    <div className="card-table table-responsive" style={{ height: "550px" }}>
      <table
        className="table card-table table-vcenter fw-bold"
        style={{ fontSize: "130%" }}
      >
        <thead>
          <tr>
            <th style={{ fontSize: "100%" }}>Name</th>
            <th style={{ fontSize: "100%" }}>p.f</th>
            <th style={{ fontSize: "100%" }}>calls</th>
            <th
              style={{ fontSize: "100%" }}
              colSpan={2}
              data-bs-toggle="modal"
              data-bs-target="#modal-large"
              id="open-modal"
            >
              Sale
            </th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data?.map((data, index) => {
              return (
                <tr key={index}>
                  <td style={getFontSize(index)}>
                    {data?.employeeName || "N/A"}
                  </td>
                  <td style={{ fontSize: "120%" }}>{data?.pendingFollowup}</td>
                  <td>{`${data.callData} (${data.callDataMonth || 0})`}</td>
                  <td style={{ fontSize: "120%" }}>
                    ₹{formatToIndianNumberingSystem(data?.leaderBoardScore)}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      <div
        className="modal modal-blur fade"
        id="modal-large"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body">
              <div className=" card-md">
                {/* <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-filled"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
                  </svg>
                </div> */}
                <div className="card-body text-center">
                  <div>
                    <img
                      src={
                        "https://res.cloudinary.com/bsgfcooa/image/upload/v1752557310/congratulations4_2_jjotsc_jts1kp_k3y9yx.png"
                      }
                      alt={"congrasulationspng"}
                      style={{ height: "250px", width: "800px" }}
                      className="mb-5"
                    ></img>
                  </div>
                  <div>
                    <span
                      className="text-green display-5 text-uppercase  fw-bold my-3"
                      style={{ fontSize: "3.1rem", fontFamily: "cursive" }}
                    >
                      {/* All other sales excluding CEA and Hydroponics */}
                      {popUpRevenue?.sellsType === "allother"
                        ? "All other sales excluding CEA and Hydroponics"
                        : popUpRevenue?.sellsType}
                    </span>
                  </div>
                  <strong style={{ fontSize: "2.1rem" }}>By</strong>
                  <ul
                    style={{ fontSize: "2.5rem", fontFamily: "sans-serif" }}
                    className="text-uppercase list-unstyled lh-lg"
                  >
                    {popUpRevenue?.generatedBy}
                    {/* <b>Saurav Chavan</b>  */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderBoard;
